import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { SquareArrowOutUpRight } from "lucide-react";
import { useQueryParamsHook } from "../../../utils/useQueryParamsHook";
import { RELATED_SERVICES, parseOpenServiceKeys } from "../variables/related-services";

const SidebarContainer = styled.div`
    width: 250px;
    min-height: 100vh;
    background-color: #f8f9fa;
    border-right: 1px solid #e0e0e0;
    padding: 20px 0;
    overflow-y: auto;
`;

const SidebarTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0 0 20px;
    padding: 0 20px;
`;

const SidebarList = styled.ul`
    list-style-type: none;
    padding: 0 16px;
    margin: 0;
`;

const SidebarItem = styled.li`
    padding: 10px 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #e9ecef;
    }
`;

const ItemName = styled.span`
    font-size: 14px;
    color: #333;

    &.selected {
        color: var(--blueColor1);
        font-weight: 700;
    }
`;

const WegetSidebar = ({ items }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParamsHook = useQueryParamsHook();

    const handleRoute = (path) => {
        navigate(path);
    };

    const openKeys = parseOpenServiceKeys(queryParamsHook?.params?.panels);

    const handleOpenPanel = (serviceKey) => {
        // 이미 열린 탭이면 활성만 전환, 아니면 탭 추가 후 활성화
        const nextKeys = openKeys.includes(serviceKey) ? openKeys : [...openKeys, serviceKey];

        queryParamsHook.setSearchParams(
            { ...queryParamsHook.params, panels: nextKeys.join(','), activePanel: serviceKey },
            { replace: false }
        );
    };

    const handleOpenNewTab = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <SidebarContainer>
            <SidebarTitle>메뉴</SidebarTitle>
            <SidebarList>
                <div className='text-xs font-medium text-gray-400 px-[8px] mt-[20px] mb-1'>기능</div>
                <SidebarItem
                    onClick={() => handleRoute("/return-exchange/register")}
                >
                    <ItemName
                        className={`${location.pathname === "/return-exchange/register" ? "selected" : ""}`}
                    >
                        등록
                    </ItemName>
                </SidebarItem>
                <SidebarItem
                    onClick={() => handleRoute("/return-exchange/search")}
                >
                    <ItemName
                        className={`${location.pathname === "/return-exchange/search" ? "selected" : ""}`}
                    >
                        조회
                    </ItemName>
                </SidebarItem>
                <SidebarItem
                    onClick={() => handleRoute("/return-exchange/archive")}
                >
                    <ItemName
                        className={`${location.pathname === "/return-exchange/archive" ? "selected" : ""}`}
                    >
                        보관함
                    </ItemName>
                </SidebarItem>
                <SidebarItem
                    onClick={() =>
                        handleRoute("/return-exchange/download-form")
                    }
                >
                    <ItemName
                        className={`${location.pathname === "/return-exchange/download-form" ? "selected" : ""}`}
                    >
                        다운로드 폼 관리
                    </ItemName>
                </SidebarItem>
                <div className='text-xs font-medium text-gray-400 px-[8px] mt-[20px] mb-1'>연관 서비스</div>
                {RELATED_SERVICES.map((service) => (
                    <SidebarItem
                        key={service.key}
                        onClick={() => handleOpenPanel(service.key)}
                        className='flex items-center gap-1'
                    >
                        <ItemName
                            className={`flex-1 ${openKeys.includes(service.key) ? "selected" : ""}`}
                        >
                            {service.name}
                        </ItemName>
                        <button
                            type='button'
                            title='새 탭으로 열기'
                            onClick={(e) => {
                                e.stopPropagation();
                                handleOpenNewTab(service.url);
                            }}
                            className='flex items-center'
                        >
                            <SquareArrowOutUpRight size={14} className='text-gray-700' />
                        </button>
                    </SidebarItem>
                ))}
            </SidebarList>
        </SidebarContainer>
    );
};

export default WegetSidebar;
